import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35a19267"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-content py-5" }
const _hoisted_2 = { class: "title mt-5" }
const _hoisted_3 = { class: "mt-2" }

import { useDialogStore } from '@/stores/dialogs';


export default /*#__PURE__*/_defineComponent({
  __name: 'SuccesDialog',
  props: {
    title: null,
    content: null
  },
  setup(__props: any) {

const props = __props as { title?: string, content?: string }



const dialogStore = useDialogStore()
const close = () => { 
  dialogStore.close()
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, { color: "primary" }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-check-circle")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.title || "Вы успешно добавили новую команду"), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.content || "Используйте шаблон команды для прикрепления к программам обучения"), 1),
    _createVNode(_component_v_btn, {
      color: "primary mt-6 w-100",
      onClick: close
    }, {
      default: _withCtx(() => [
        _createTextVNode("Окей")
      ]),
      _: 1
    })
  ]))
}
}

})